<template>
  <div class="iq-card pl-3 pr-3 pt-5 pb-5">
    <div id="report-4">
      <div class="">
        <table style="width: 100%">
          <tr>
            <table style="width: 100%; margin: 0; padding: 0">
              <tr>
                <th style="width: 25%">
                  <div class="logo">
                    <img
                      src="../../../assets/images/vehicle-solutions-logo-type1.png"
                      class="img-fluid"
                    />
                  </div>
                </th>
                <th style="width: 75%">
                  <div class="text-right">
                    <h4
                      style="
                        color: #3f414d;
                        font-family: 'Roboto Condensed';
                        font-size: 3rem;
                        font-weight: 700;
                        line-height: 1;
                        margin-bottom: 0;
                      "
                    >
                      BDM Commission
                    </h4>
                    <p>Dealer</p>
                    <p
                      style="
                        font-weight: 700;
                        margin-top: 20px;
                        margin-bottom: 0;
                      "
                    >
                      {{ commissionYear }} to
                      {{ commissionMonth }}
                    </p>
                  </div>
                </th>
              </tr>
            </table>
          </tr>
          <tr v-if="comGetRptData">
            <table style="width: 100%; margin: 0; padding: 0; margin-top: 25px">
              <tr class="tbl-header-blue">
                <th>Dealer</th>
                <th class="tbl-right">Vehicle Price</th>
                <th class="tbl-right">Settlement Date</th>
                <th class="tbl-right">NAF</th>
                <th class="tbl-right">Commission</th>
                <th class="tbl-right">Bonus Bucket</th>
              </tr>
              <tr class="tbl-tr-no-data">
                <td colspan="6"></td>
              </tr>

              <template v-for="item in comGetRptData">
                <tr class="tbl-header-gray">
                  <td colspan="6">
                    <div class="row">
                      <div class="col-lg-9 col-md-9 col-12">
                        <div>
                          BDM -
                          {{ item[0].referredByBDMName }}
                        </div>
                      </div>
                      <div class="col-lg-3 col-md-3 col-12 text-right">
                        <button
                          class="btn btn-primary btn-sm"
                          @click="fnDownloadCommission(item[0])"
                        >
                          Download
                          <b-spinner
                            small
                            v-if="loading && referredByBDM == item[0].referredByBDM"
                          ></b-spinner>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                <template v-for="record in item">
                  <tr class="tbl-border-bottom">
                    <td colspan="1">
                      <span v-if="record.dealerName">
                        {{
                          record.dealerName
                        }}
                      </span>
                    </td>
                    <td colspan="1" class="tbl-right">
                      {{ record.settlementDate}}
                    </td>
                    <td colspan="1" class="tbl-right">
                      $ {{ record.totalDriveAwayCost | with-decimal}}
                    </td>
                    <td colspan="1" class="tbl-right">
                      $ {{ record.financeNAF | with-decimal}}
                    </td>
                    <td colspan="1" class="tbl-right">
                      $ {{ record.bdmCommission | with-decimal}}
                    </td>
                    <td colspan="1" class="tbl-right">
                      $ {{ record.bonusBucketCommission | with-decimal}}
                    </td>

                  </tr>
                </template>
                <template>
                  <tr>
                    <td colspan="1"></td>
                    <td colspan="1"></td>
                    <td colspan="1"></td>
                    <td colspan="1"></td>
                    <td colspan="1" class="tbl-right fw-700">
                      $ {{ getCommission(item) |with-decimal }}
                    </td>
                    <td colspan="1" class="tbl-right fw-700">
                      $ {{ getBucketCommission(item) |with-decimal}}
                    </td>
                  </tr>
                </template>
                <tr class="tbl-tr-no-data">
                  <td colspan="6"></td>
                </tr>
              </template>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="tbl-right fw-700">TOTAL</td>
                <td class="tbl-right fw-700">
                  $ {{ Number(comGetTotalCommissions)  |with-decimal}}
                </td>
                <td class="tbl-right fw-700">
                  $ {{ Number(comGetTotalBucketCommissions)  |with-decimal}}
                </td>
              </tr>
            </table>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import store from '../../../store/modules/base.module'
import * as dashboardBDMService from '../../../services/dashboardBDM.service';
import * as messageService from '../../../services/message.service'

export default {
  name: 'VSAEOMDEInvoice',
  props:[ 'prosData','commissionYear','commissionMonth', 'referredByBDM', 'stakeHolderType'],
  data() {
    return {
      errors: '',
      loading: false,
    }
  },
  computed: {
    comGetRptData() {
      let arr = this.prosData
      let groupBy = (array, key) => {
        return array.reduce((result, obj) => {
          ;(result[obj[key]] = result[obj[key]] || []).push(obj)
          return result
        }, {})
      }

      let sortFilter = (a, b) => {
        return a.referredByBDM - b.referredByBDM
      }

      let a = groupBy(arr.sort(sortFilter), 'referredByBDM')
      let b = Object.values(a)

      return b
    },
    comGetTotalCommissions() {
      let arr = this.prosData
      let totalPrice = arr.reduce((accumulator, item) => {
        return accumulator + Number(item.bdmCommission)
      }, 0)
      return totalPrice
    },
    comGetTotalBucketCommissions() {
      let arr = this.prosData
      let totalPrice = arr.reduce((accumulator, item) => {
        return accumulator + Number(item.bdmCommission)
      }, 0)
      return totalPrice
    }
  },
  methods: {
    // Get Individual bucket commission
    getBucketCommission(item) {
      let sum = 0
      item.forEach((record) => {
        sum += Number(record.bonusBucketCommission)
      })
      return sum.toFixed(2)
    },

    //Get Individual commission
    getCommission(item) {
      let sum = 0
      item.forEach((record) => {
        sum += Number(record.bdmCommission)
      })
      return sum.toFixed(2)
    },

    /**
     * To Download Individual commissions a pdf document
     * @param {*} referredByBDM
     */
    async fnDownloadCommission(bdm) {
      this.loading = true


      try {
        this.errors = {}

        const filePath = await dashboardBDMService.bdmCommissionsDownload({
          commissionYear: this.commissionYear,
          commissionMonth: this.commissionMonth,
          referredByBDM:bdm.referredByBDM,
          stakeHolderTypeView: this.stakeHolderType
        })

        console.log('filePath', filePath);
        // Download from BDM Commissions Report in temp folder
        window.open(`${store.state.serverPath}/` + filePath.data, '_blank')

        this.loading = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Data range',
              'Something wrong'
            )
            break
        }
        this.loading = false
      }
    },
  }
}
</script>
<style>
@page {
  /* size: A4 portrait; */
  /* margin: 0cm 0cm; */
  width: 210mm;
  height: 290mm;
  margin: 0px 20px 0px 20px;
}
@media print {
  body * {
    visibility: hidden !important;
  }
  #reportConsoleLeftSide {
    display: none !important;
  }
  #reportConsoleRightSide.col-lg-8,
  #reportConsoleRightSide.col-md-8 {
    -ms-flex: 0 0 100%;
    -webkit-box-flex: 0;
    flex: 0 0 100%;
    max-width: 100%;
  }
  #report-4,
  #report-4 * {
    visibility: visible !important;
  }
  #report-4 {
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    margin: 0;
    /* width: 210mm; */
    /* height: 297mm; */
  }
}
#report-4 .logo img {
  height: 125px !important;
  width: auto;
  border-radius: 0px;
}
#report-4 .img-fluid {
  max-width: 100% !important;
  height: auto !important;
}
#report-4 .tbl-header-blue {
  background-color: var(--iq-info);
  color: var(--iq-white);
}
#report-4 .tbl-header-gray {
  background-color: var(--iq-border-light);
  color: var(--iq-title-text);
}
#report-4 .tbl-header-blue th,
#report-4.tbl-header-gray td,
#report-4 td {
  font-size: 1.1rem;
}
#report-4 tr th,
#report-4 tr td {
  padding: 15px;
}
#report-4 tr.tbl-tr-no-data td {
  padding: 10px;
}
#report-4 tr.tbl-tr-no-data30-gray td {
  padding: 30px;
  background-color: var(--iq-border-light);
}
#report-4 .tbl-border-bottom {
  border-bottom: 1px solid var(--iq-border-light);
}
#report-4 .tbl-border-bottom3 {
  border-bottom: 3px solid var(--iq-border-light);
}
#report-4 .tbl-border-bottom4 {
  border-bottom: 3px solid var(--iq-info);
}
#report-4 .tbl-left {
  text-align: left;
}
#report-4 .tbl-right {
  text-align: right;
}
#report-4 .tbl-center {
  text-align: center;
}

#report-4 .footer {
  position: relative;
  bottom: 0;
}

#report-4 tr td p {
  font-size: 1.1rem;
}
.bg-info {
  background-color: var(--iq-info);
}
.text-info {
  color: #38afef;
}
.fw-600 {
  font-weight: 600;
}
.mb-0 {
  margin-bottom: 0;
}
</style>
